var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2197 6.46967C13.5126 6.17678 13.9874 6.17678 14.2803 6.46967L19.2803 11.4697C19.5732 11.7626 19.5732 12.2374 19.2803 12.5303L14.2803 17.5303C13.9874 17.8232 13.5126 17.8232 13.2197 17.5303C12.9268 17.2374 12.9268 16.7626 13.2197 16.4697L17.6893 12L13.2197 7.53033C12.9268 7.23744 12.9268 6.76256 13.2197 6.46967Z",
    fill: "#282A2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21967 6.46967C6.51256 6.17678 6.98744 6.17678 7.28033 6.46967L12.2803 11.4697C12.5732 11.7626 12.5732 12.2374 12.2803 12.5303L7.28033 17.5303C6.98744 17.8232 6.51256 17.8232 6.21967 17.5303C5.92678 17.2374 5.92678 16.7626 6.21967 16.4697L10.6893 12L6.21967 7.53033C5.92678 7.23744 5.92678 6.76256 6.21967 6.46967Z",
    fill: "#282A2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleNext);
export default __webpack_public_path__ + "static/media/Double-Next.da0eab48a3d6e8b16daf4f7f24e84657.svg";
export { ForwardRef as ReactComponent };